export default "__VITE_ASSET__d66f703c__"